import script from "./pwaDownloadCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./pwaDownloadCard.vue?vue&type=script&lang=ts&setup=true"

import "./pwaDownloadCard.vue?vue&type=style&index=0&id=538eea27&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-538eea27"]])

export default __exports__